import React from 'react'
import Subheader from '../../component/Subheader'
import CollaborationContent from './CollaborationContent'
import CollaborationSlider from './CollaborationSlider'

export default function Collaboration() {
    const subheadData = {
      image: '../image/collaboration-banner.webp',
      title: 'World of Sonam Label’s',
      heading: 'A Showcase of Stars in Sonam’s Couture',
      pagename: 'Collaboration',
    }

  return (
    <>
      <Subheader subheadData={subheadData}/>
      <CollaborationContent/>
      <CollaborationSlider/>
    </>
  )
}
